import Typography from "@vapor/react-extended/ExtendedTypography";
import Grid from "@vapor/react-material/Grid";
import { useDocumentList } from "../../state/useDocumentList";

const DeletedDataTrashbinCell = ({ formattedDate }) => {
  const { documentFilterOption } = useDocumentList();
  return (
    <>
      {documentFilterOption === "CESTINO" && (
        <Grid item sm={6}>
          <Typography variant="body" fontWeight={400}>
            {formattedDate}
          </Typography>
        </Grid>
      )}
    </>
  );
};

export default DeletedDataTrashbinCell;
